import {Offer} from './offer';
import {VersionFieldChange} from '../proposal/proposal-version-history-entry';

export {VersionFieldChange};

export class OfferVersionHistoryEntry {
  offer: Offer = new Offer();
  changes: VersionFieldChange[] = [];

  constructor(raw?: any) {
    if (raw == null) {
      return;
    }
    this.offer = new Offer(raw.offer);
    this.changes = Array.isArray(raw.changes) ? raw.changes : [];
  }
}
